import { languageStringsAdmin } from "./cs/admin";
import { languageStringsCampaign } from "./cs/campaign";
import { languageStringsContact } from "./cs/contact";
import { languageStringsPopups } from "./cs/popup";
import { languageStringsSubscriptions } from "./cs/subscriptions";

export const cs = {
  sidePanel: {
    campaign: "Kampaň",
    connection: "Propojení",
    settings: "Nastavení",
    infinite: "Bez omezení",
  },
  noTariffBanner: {
    title: "Váš účet nemá aktivní žádný tarif",
    description:
      "Bez aktivního tarifu nemůžeme zobrazit notifikace na Vašich stránkách a zvyšovat tak jejich konverzní poměr.",
    button1: "Aktivovat tarif",
    button2: "na prvních 14 dnů zdarma",
  },
  noPixelBanner: {
    title: "Na webové stránce není vložen pixel script.",
    description: "Pro zprovoznění notifikací, vložte pixel script",
    button: "Jak vložit pixel?",
  },
  extraCreditsPage: {
    buttonText: "Koupit",
    shows: "zobrazení",
    navigationButtonText: "Dokoupit",
    purchaseError:
      "Platbu se nepodařilo spustit. Zkuste to prosím znovu později nebo kontaktujte podporu.",
  },
  choose: "Vybrat",
  apiKeysTitle: "Propojení - zobrazujte recenze spokojených zákazníků",
  zboziApiChangeNotice: "Upozornění: Zboží.cz API bylo nahrazeno novým Sklik API. Pokud máte propojení se Zboží.cz, je nutné aktualizovat API klíč – nový refresh token získáte na sklik.cz v sekci Nastavení → API klíče.",
  addingApiKeys: "Přidání API klíčů",
  optionalAddApiKey:
    "Tento krok je dobrovolný. API klíče můžete přidat později",
  monthlyCredits: "Zbývající měsíční kredity",
  portableCredits: "Extra zakoupené kredity",
  extraCredits: "Extra zakoupené kredity",
  help: "Nápověda",
  reportProblem: "Nahlásit chybu",
  saveChanges: "Uložit změny",
  reset: "Reset",
  defaultSettings: "Výchozí nastavení",
  addKey: "Přidat klíč",
  login: "Přihlásit se",
  back: "Zpět",
  close: "Zavřít",
  delete: "Vymazat",
  verified: "Ověřeno",
  yes: "Ano",
  notVerified: "Neověřeno",
  connected: "Propojeno",
  active: "Aktivní",
  inactive: "Neaktivní",
  check: "Zkontrolovat",
  add: "Přidat",
  edit: "Upravit",
  save: "Uložit",
  continue: "Pokračovat",
  userIsNotLoggedIn: "Uživatel není přihlášen",
  deleteWebsite: "Vymazat web",
  spolehliveRecenze: "Spolehlive Recenze",
  logout: "Odhlásit",
  paymentFailed: {
    title: "Platba byla zrušena",
    description: "Platbu se nepodařilo dokončit.",
    continue: "Zkusit znovu",
  },
  paymentRejected: {
    title: "Platba byla zamítnuta",
    description: "Platba nebyla přijata. Zkuste to prosím znova.",
    continue: "Pokračovat",
  },
  notFound: {
    title: "Nenašli jsme požadovanou stránku",
    back: "Zpět",
  },
  loggedOut: {
    title: "Byl jste odhlášen",
    description: "Stránku můžete zavřít.",
    close: "Zavřít stránku",
  },
  passwordChange: {
    title: "Změna hesla",
    setPasswordTitle: "Nastavení hesla",
    oldPassword: "Současné heslo",
    newPassword: "Nové heslo",
    password: "Heslo",
    confirmPassword: "Potvrďte nové heslo",
    passwordMismatch: "Hesla se neshodují",
    passwordSet: "Heslo bylo nastaveno, přihlaste se znovu.",
    passwordSetFailed: "Nepodařilo se nastavit heslo",
    passwordChanged: "Heslo bylo změněno, přihlaste se znovu.",
    passwordChangeFailed: "Nepodařilo se změnit heslo",
    errors: {
      passwordsDoNotMatch: "Hesla se neshodují",
      failedToChange: "Nepodařilo se změnit heslo",
    },
    success: "Heslo bylo změněno, přihlaste se znovu.",
  },
  onBoarding: {
    title: "Přidejte svůj první web",
    description:
      "Nebojte se, provedeme vás krok po kroku. Brzo budete moč využívat všech výhod, které Ověřený web přínáší.",
    start: "Začít",
    logout: "Odhlásit se",
    errors: {
      websiteNameTaken: "Web s tímto názvem je již obsazen",
      fillAllFields: "Vyplňte všechna pole",
      enterApiKey: "Zadejte API klič",
      enterCredentials: "Zadejte uživatelské jméno a heslo",
    },
    apiKeyModal: {
      added: "Přidáno.",
      notVerified: "Není ověřeno",
      zbozi: {
        noAccessToPremise: "API klíč nemá přístup k dané provozovně. Možné příčiny: (1) Klíč patří jinému Sklik účtu než ten, který spravuje tuto provozovnu. (2) Provozovna nemá aktivní měření konverzí na Zboží.cz – bez něj nelze API recenzí využívat. Nastavení měření konverzí: zbozi.cz/mereni-konverzi",
        invalidApiKey: "API klíč je neplatný nebo vypršel. Vygenerujte nový klíč v Nastavení → API klíče ve Skliku.",
        insufficientPermissions: "API klíč nemá dostatečná oprávnění. Ve Skliku vytvořte nový klíč s oprávněním pro Zboží.cz / Nákupy data.",
        verificationFailed: "Ověření se nezdařilo. Zkontrolujte API klíč a ID provozovny.",
      },
    },
  },
  resetPassword: {
    title: "Resetovat heslo",
    reset: "Resetovat",
    emailSent: "Pokud účet s tímto emailem existuje, obdržíte instrukce pro reset hesla.",
    newPassword: "Nové heslo",
    confirmPassword: "Potvrďte heslo",
    submit: "Resetovat heslo",
    backToLogin: "Zpět na přihlášení",
    success: "Heslo úspěšně resetováno",
    successMessage: "Vaše heslo bylo resetováno. Všechny relace byly odhlášeny. Nyní se můžete přihlásit s novým heslem.",
    invalidLink: "Neplatný odkaz",
    errorTitle: "Neplatný odkaz pro reset",
    errorMessage: "Tento odkaz je neplatný nebo vypršel. Požádejte o nový odkaz pro reset hesla.",
    passwordTooShort: "Heslo musí mít alespoň 8 znaků",
    passwordsMismatch: "Hesla se neshodují",
    genericError: "Nepodařilo se resetovat heslo. Zkuste to prosím znovu.",
    description: "Zadejte své nové heslo",
    redirecting: "Přesměrování na přihlášení",
  },
  deleteWeb: {
    title: "Vymazat web?",
    description: "Veškerá data a kampaně budou vymazány.",
    delete: "Vymazat",
    close: "Zavřít",
  },
  loginScreen: {
    title: "Přihlášení",
    email: "Email",
    password: "Heslo",
    button: "Přihlásit se",
    newUsers: "Nový uživatel?",
    forgotPassword: "Zapomněli jste heslo?",
    resetPassword: "Resetovat",
    signUp: "Registrujte se",
  },
  registrationScreen: {
    title: {
      first: "Jste jen jeden krok od",
      second: "zvýšení konverzního poměru",
      third: "Vašeho e-shopu ",
      fourth: "až o 20 %!",
    },
    subTitle: "Vyplňte následující údaje a připojte se k úspěšným e-shopařům",
    name: "Jméno",
    phone: "Telefonní číslo (nepovinné)",
    email: "Email",
    password: "Heslo",
    confirmPassword: "Potvrďte heslo",
    accept: "Souhlasím s",
    terms: "podmínkami",
    button: "DOKONČIT REGISTRACI",
    alreadyHaveAccount: "Máte účet?",
    login: "Přihlásit se",
  },
  addWebsite: {
    title: "Přidejte web",
    name: "Název webu",
    warning: "Vložte celou URL adresu Vaší webové stránky včetně https.",
    includeHttps: "včetně https",
    url: "URL webu",
    notificationLanguage: "Jazyk notifikací",
    czech: "Čeština",
    slovak: "Slovenština",
    polish: "Polština",
  },
  howToInstallPixel: {
    title: "Jak nainstalovat pixel",
    first: "Zkopírujte kód Pixelu.",
    second: "Vložte kód do hlavičky Vašeho webu na Váš web před </head>.",
    third:
      "Navštivte Vaší stránku, tím aktivujete pixel kód. Následně zkontrolujte pomocí tlačítka “Zkontrolovat”.",
    help: "Jak vložit pixel kód na webové stránky?",
  },
  websites: {
    title: "Zobrazit všechny",
    website: "Web",
    created: "Vytvořena",
    campaigns: "Kampaně",
    addWebsite: "Přidat web",
    connect: "Propojit",
    connected: "Propojeno",
    yourWebsites: "Vaše weby",
    addButton: "Přidat",
    backButton: "Zpět",
  },
  iconSelect: {
    selectedIcon: "Vybraná ikona",
    selectIcon: "Kliknete pro výběr ikony",
    dialogTitle: "Vyberte ikonu",
    dialogClose: "Zavřít",
  },
  settingsTabs: {
    webSettings: "Základní nastavení",
    customLogo: "Vlastní logo",
  },
  customLogo: {
    showLogo: "Zobrazovat logo",
    logo: "Logo",
    text: "Text",
    textColor: "Barva textu",
    save: "Uložit",
  },
  shoptetFirstTouchScreen: {
    title: "Instalace doplňku byla úspěšná.",
    description1:
      "Připravili jsme pro Váš e-shop sadu chytrých notifikací, které dle našich zkušeností s podobnými e-shopy nejefektivněji zvýší počet objednávek Vašeho e-shopu. Ty se spustí automaticky. Ihned po aktivaci Vaší zkušební jízdy zdarma.",
    description2:
      "Klikněte na tlačítko. Aktivujte si chytré notifikace a už jen pozorujte, jak každý den roste počet objednávek.",
    button: "Spustit testovacích 14 dní zdarma",
    error: "Přihlášení se nezdařilo odhlašte se a zkuste to znovu.",
  },
  webarealFirstTouchScreen: {
    title: "Instalace doplňku byla úspěšná.",
    description1:
      "Připravili jsme pro Váš e-shop sadu chytrých notifikací, které dle našich zkušeností s podobnými e-shopy nejefektivněji zvýší počet objednávek Vašeho e-shopu. Ty se spustí automaticky. Ihned po aktivaci Vaší zkušební jízdy zdarma.",
    description2:
      "Klikněte na tlačítko. Aktivujte si chytré notifikace a už jen pozorujte, jak každý den roste počet objednávek.",
    button: "Spustit testovacích 14 dní zdarma",
    error: "Přihlášení se nezdařilo odhlašte se a zkuste to znovu.",
  },
  eshopRychleFirstTouchScreen: {
    title: "Vítejte v Ověřený web!",
    description1: "Váš účet byl úspěšně vytvořen.",
    description2: "Prosím nastavte si heslo pro přihlášení do administrace.",
    button: "Nastavit heslo",
    error: "Přihlášení se nezdařilo. Zkuste to prosím znovu.",
  },
  upgatesFirstTouchScreen: {
    title: "Instalace doplňku byla úspěšná.",
    description1:
      "Připravili jsme pro Váš e-shop sadu chytrých notifikací, které dle našich zkušeností s podobnými e-shopy nejefektivněji zvýší počet objednávek Vašeho e-shopu. Ty se spustí automaticky. Ihned po aktivaci Vaší zkušební jízdy zdarma.",
    description2:
      "Klikněte na tlačítko. Aktivujte si chytré notifikace a už jen pozorujte, jak každý den roste počet objednávek.",
    button: "Spustit testovacích 14 dní zdarma",
    error: "Přihlášení se nezdařilo odhlašte se a zkuste to znovu.",
  },
  shopifyFirstTouchScreen: {
    title: "Instalace aplikace byla úspěšná.",
    description1:
      "Připravili jsme pro Váš Shopify obchod sadu chytrých notifikací, které dle našich zkušeností s podobnými obchody nejefektivněji zvýší počet objednávek. Ty se spustí automaticky. Ihned po aktivaci Vaší zkušební jízdy zdarma.",
    description2:
      "Klikněte na tlačítko. Aktivujte si chytré notifikace a už jen pozorujte, jak každý den roste počet objednávek.",
    button: "Spustit testovacích 14 dní zdarma",
    error: "Přihlášení se nezdařilo. Zkuste to prosím znovu.",
  },
  trustPilot: {
    businessUnitId: "ID obchodní jednotky",
    apiKey: "API klíč",
    apiSecret: "API tajný klíč",
    reviews: "recenze",
    reviewsWithRating: "Recenze s více než",
    stars: "hvězdičkami",
    maxReviews: "Minimální počet recenzí k zobrazení",
    verificationPrompt:
      "Prosím ověřte váš TrustPilot API klíč a ID obchodní jednotky",
    sourceUrlAddress: "Zadejte ID vaší obchodní jednotky",
  },
  errors: {
    pixelCheckFailed: "Automatická kontrola Pixelu nebyla úspěšná.",
    placesApiError: "Při načítání dat z Google Maps došlo k chybě. Prosím kontaktujte nás pro pomoc.",
    userNotFound: "Uživatel s tímto emailem neexistuje",
    userAlreadyExists: "Uživatel s tímto emailem již existuje",
    fillAllFields: "Vyplňte všechna povinná pole",
    passwordsDoNotMatch: "Hesla se neshodují",
    termsRequired: "Je vyžadován souhlas s podmínkami",
    invalidEmail: "Zadejte validní email",
    logoFileTooLarge: "Logo je příliš velké. Maximální velikost je {{maxSize}} KB, váš soubor má {{actualSize}} KB.",
    logoFileTooLargeSimple: "Logo je příliš velké. Maximální velikost souboru je 100 KB.",
    failedToLoadSettings: "Nepodařilo se načíst nastavení",
    // Backend error types
    Generic: "Došlo k neočekávané chybě",
    Unauthorized: "Nemáte oprávnění k této akci",
    Unhandled: "Neošetřená chyba",
    NotEnoughCredits: "Nemáte dostatek kreditů",
    IntegrityHashNotFound: "Platnost relace vypršela, přihlaste se znovu",
    ErrorVerifyingAccessToken: "Chyba při ověřování přístupového tokenu",
    MissingAccessToken: "Chybí přístupový token",
    AccessTokenExpired: "Platnost přístupového tokenu vypršela",
    InvalidCredentials: "Špatné přihlašovací údaje",
    UserEmailAlreadyExists: "Uživatel s tímto emailem již existuje",
    EmailNotSent: "Nepodařilo se odeslat email, zkuste to prosím později",
    ItemNotFound: "Položka nebyla nalezena",
    WebsiteNotFound: "Web nebyl nalezen",
    UserNotFound: "Uživatel nebyl nalezen",
    CampaignNotFound: "Kampaň nebyla nalezena",
    NotificationSettingsNotFound: "Nastavení notifikace nebylo nalezeno",
    ParameterBadFormat: "Neplatný formát parametru",
    QueryStringMissing: "Chybí parametr v URL",
    BodyParameterMissing: "Chybí parametr v požadavku",
    EnvVarNotFound: "Chybí konfigurační proměnná",
    PricingPlanNotFoundInStripe: "Tarif neexistuje v databázi Stripe",
    PricingPlanInconsistencyInStripe: "Nekonzistence v databázi tarifů Stripe",
    PriceNotFoundInStripe: "Cena tarifu neexistuje v databázi Stripe",
    CustomerNotFoundInStripe: "Zákazník neexistuje v databázi Stripe",
    SubscriptionInconsistencyInStripe: "Nekonzistence v databázi předplatného Stripe",
    SubscriptionNotFoundInStripe: "Předplatné nebylo nalezeno v Stripe",
    PricingPlanCreditsNotFound: "Počet kreditů není nastaven u tarifu",
    StripeWebhookError: "Chyba Stripe webhooku",
    CustomerDeletedInStripe: "Zákazník je smazán v databázi Stripe",
    UnexpectedStripeInvoicePayload: "Neočekávaná data od Stripe",
    StripeSessionUrlError: "Chyba URL platební relace Stripe",
    ThirdPartyApiError: "Chyba externí API",
    UserWithoutPasswordError: "Uživatel nemá nastavené heslo, byl pravděpodobně registrován z externího systému",
    PrivateKeyDoesNotMatch: "Soukromý klíč nesouhlasí",
    UserNotDeletedInStripe: "Uživatel nebyl smazán ze systému Stripe",
    InvalidRequestBody: "Neplatný formát požadavku",
    UserNotRegisteredThroughWebareal: "Uživatel nebyl registrován přes Webareal",
    WebarealWebsiteAlreadyExists: "Tento Webareal e-shop je již registrován",
    UserNotRegisteredThroughUpgates: "Uživatel nebyl registrován přes Upgates",
    RedisClientNotFound: "Redis klient nebyl nalezen",
    PayloadTooLarge: "Požadavek je příliš velký",
  },
  cancelSubscription: {
    title: "Opravdu si přejete zrušit obnovu předplatného?",
    confirmButton: "Ano zrušit",
    cancelButton: "Zpět",
  },
  admin: languageStringsAdmin,
  campaign: languageStringsCampaign,
  subscriptions: languageStringsSubscriptions,
  contact: languageStringsContact,
  popups: languageStringsPopups,
};
